// Geometría del riel compartido del home. Vive aparte —y no dentro de main.js—
// porque main.js arrastra three.js: cualquiera que necesitara estas tres cifras
// se llevaba 864 KB de propina, incluido el hero, que es el elemento del LCP.
//
// Aquí no se importa NADA. Es la condición para que siga siendo barato.

// Cuánto scroll ocupa el hero de Julio antes de que arranque el recorrido 3D.
export const HERO_LEAD_PX = 1100;

// Cuánto dura cada escena, en alturas de pantalla.
export const VH_PER_SCENE = 140;

// Número de escenas del recorrido. Se duplica a propósito para no tener que
// importar `SCENES` (que trae three.js) solo para contar; `scenes/index.js`
// verifica en desarrollo que las dos cifras coincidan y avisa si se separan.
export const SCENE_COUNT = 5;
